/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Divider } from "primereact/divider";
import { Sidebar, tituloBase } from "../../../../../shared";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import {
  accessAPI,
  Boton,
  Titulo,
  Formulario,
  CampoInformacion,
  TablaFiltrable
} from "../../../../../shared";
export default function RequerimientoFormacionColaborador() {
  const [loader, setLoader] = useState(true);
  const [requerimiento, setRequerimiento] = useState();
  const [loaderEstado, setLoaderEstado] = useState(false);
  const [activo, setActivo] = useState();
  const [porNorma, setPorNorma] = useState();
  const [porEsquema, setPorEsquema] = useState();

  const [sideBarEditar, setSideBarEditar] = useState(false);
  const [loaderEditar, setLoaderEditar] = useState(false);
  const [formEditarKey, setFormEditarKey] = useState(0);

  const [tiposAuditor, setTiposAuditor] = useState([]);
  const [sideBarTipo, setSideBarTipo] = useState(false);
  const [loaderTipo, setLoaderTipo] = useState(false);
  const [formTipoKey, setFormTipoKey] = useState(0);

  const [normasAsociadas, setNormasAsociadas] = useState([]);
  const [sideBarNorma, setSideBarNorma] = useState(false);
  const [loaderNorma, setLoaderNorma] = useState(false);
  const [formNormaKey, setFormNormaKey] = useState(0);

  const [esquemasAsociados, setEsquemasAsociados] = useState([]);
  const [sideBarEsquema, setSideBarEsquema] = useState(false);
  const [loaderEsquema, setLoaderEsquema] = useState(false);
  const [formEsquemaKey, setFormEsquemaKey] = useState(0);

  const toast = useRef(null);
  const { formacionId } = useParams();

  function cargarRequerimiento() {
    accessAPI(
      "GET",
      `admin/formacioncolaborador/${formacionId}`,
      null,
      (respuesta) => {
        setRequerimiento(respuesta);
        setActivo(respuesta.activo);
        setPorNorma(respuesta.porNorma);
        setPorEsquema(respuesta.porEsquema);
        setTiposAuditor(
          respuesta.RequerimientoFormacionColaborador_x_AuditorTipo || []
        );
        setNormasAsociadas(
          respuesta.RequerimientoFormacionColaborador_x_Norma || []
        );
        setEsquemasAsociados(
          respuesta.RequerimientoFormacionColaborador_x_Esquema || []
        );
        document.title = respuesta.nombre;
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar requerimiento",
          sticky: true
        });
        setLoader(false);
      }
    );
  }

  useEffect(() => {
    cargarRequerimiento();
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formacionId]);

  function guardarEdicion(contenidoCampos) {
    setLoaderEditar(true);
    accessAPI(
      "PUT",
      `admin/formacioncolaborador/${requerimiento.id}`,
      contenidoCampos,
      () => {
        setSideBarEditar(false);
        setLoaderEditar(false);
        cargarRequerimiento();
      },
      (respuesta) => {
        setLoaderEditar(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al guardar",
          sticky: true
        });
      }
    );
  }

  function getEditarFormConfig() {
    return {
      secciones: [
        {
          campos: [
            {
              nombre: "nombre",
              tipoitemformularioid: 1,
              etiqueta: "Nombre del requerimiento",
              requerido: true,
              respuesta: requerimiento.nombre || ""
            },
            {
              nombre: "porNorma",
              tipoitemformularioid: 6,
              etiqueta: "Se debe cumplir por norma",
              respuesta: requerimiento.porNorma
            },
            {
              nombre: "porEsquema",
              tipoitemformularioid: 6,
              etiqueta: "Se debe cumplir por esquema",
              respuesta: requerimiento.porEsquema
            },
            {
              nombre: "requiereArchivo",
              tipoitemformularioid: 6,
              etiqueta: "Requiere un archivo asociado",
              respuesta: requerimiento.requiereArchivo
            },
            {
              nombre: "duracionDias",
              tipoitemformularioid: 4,
              etiqueta: "Duración de renovación (en días)",
              requerido: false,
              respuesta: requerimiento.duracionDias || ""
            },
            {
              nombre: "obligatorio",
              tipoitemformularioid: 6,
              etiqueta: "Es obligatorio para ejercer en actividades",
              respuesta: requerimiento.obligatorio
            },
            {
              nombre: "notas",
              tipoitemformularioid: 11,
              etiqueta: "Notas",
              requerido: false,
              respuesta: requerimiento.notas || ""
            }
          ]
        }
      ],
      botones: [
        {
          etiqueta: "Guardar cambios",
          callback: guardarEdicion,
          validar: true
        }
      ]
    };
  }

  function cambiarEstadoRequerimiento(nuevoEstado) {
    setLoaderEstado(true);
    accessAPI(
      "PATCH",
      `admin/formacioncolaborador/${requerimiento.id}`,
      { activo: nuevoEstado },
      (respuesta) => {
        setLoaderEstado(false);
        setActivo(respuesta.activo);
      },
      (respuesta) => {
        setLoaderEstado(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cambiar estado",
          sticky: true
        });
      }
    );
  }

  function asociarTipoAuditor(camposFormulario) {
    setLoaderTipo(true);
    accessAPI(
      "PUT",
      `admin/formacioncolaborador/porauditortipo/${requerimiento.id}`,
      camposFormulario,
      (respuesta) => {
        setLoaderTipo(false);
        setSideBarTipo(false);
        setTiposAuditor((prev) => [...prev, respuesta.registro]);
      },
      (respuesta) => {
        setLoaderTipo(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al asociar tipo",
          sticky: true
        });
      }
    );
  }

  function eliminarTipoAuditor(asociacionId) {
    accessAPI(
      "DELETE",
      `admin/formacioncolaborador/porauditortipo/${asociacionId}`,
      null,
      () => {
        setTiposAuditor((prev) => prev.filter((t) => t.id !== asociacionId));
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al eliminar asociación",
          sticky: true
        });
      }
    );
  }

  const tipoAuditorFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "auditorTipoId",
            tipoitemformularioid: 5,
            etiqueta: "Tipo de colaborador",
            opciones: "admin/auditor/auditortipo?dropdown=true",
            requerido: true,
            sinOpcionInicial: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Asociar",
        clases: "verde",
        callback: asociarTipoAuditor,
        validar: true
      }
    ]
  };

  function asociarNorma(camposFormulario) {
    setLoaderNorma(true);
    accessAPI(
      "PUT",
      `admin/formacioncolaborador/pornorma/${requerimiento.id}`,
      camposFormulario,
      (respuesta) => {
        setLoaderNorma(false);
        setSideBarNorma(false);
        setNormasAsociadas((prev) => [...prev, respuesta.registro]);
      },
      (respuesta) => {
        setLoaderNorma(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al asociar norma",
          sticky: true
        });
      }
    );
  }

  function eliminarNorma(asociacionId) {
    accessAPI(
      "DELETE",
      `admin/formacioncolaborador/pornorma/${asociacionId}`,
      null,
      () => {
        setNormasAsociadas((prev) => prev.filter((n) => n.id !== asociacionId));
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al eliminar norma",
          sticky: true
        });
      }
    );
  }

  const normaFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "normaId",
            tipoitemformularioid: 5,
            etiqueta: "Norma",
            opciones: "admin/norma",
            requerido: true,
            sinOpcionInicial: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Asociar",
        clases: "verde",
        callback: asociarNorma,
        validar: true
      }
    ]
  };

  function asociarEsquema(camposFormulario) {
    setLoaderEsquema(true);
    accessAPI(
      "PUT",
      `admin/formacioncolaborador/poresquema/${requerimiento.id}`,
      camposFormulario,
      (respuesta) => {
        setLoaderEsquema(false);
        setSideBarEsquema(false);
        setEsquemasAsociados((prev) => [...prev, respuesta.registro]);
      },
      (respuesta) => {
        setLoaderEsquema(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al asociar esquema",
          sticky: true
        });
      }
    );
  }

  function eliminarEsquema(asociacionId) {
    accessAPI(
      "DELETE",
      `admin/formacioncolaborador/poresquema/${asociacionId}`,
      null,
      () => {
        setEsquemasAsociados((prev) =>
          prev.filter((e) => e.id !== asociacionId)
        );
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al eliminar esquema",
          sticky: true
        });
      }
    );
  }

  const esquemaFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "esquemaId",
            tipoitemformularioid: 5,
            etiqueta: "Esquema",
            opciones: "admin/config/esquema",
            requerido: true,
            sinOpcionInicial: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Asociar",
        clases: "verde",
        callback: asociarEsquema,
        validar: true
      }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBarEditar}
        onHide={() => setSideBarEditar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Editar requerimiento</Titulo>
        {requerimiento && (
          <Formulario
            key={formEditarKey}
            config={getEditarFormConfig()}
            loader={loaderEditar}
          />
        )}
      </Sidebar>

      <Sidebar
        visible={sideBarTipo}
        onHide={() => setSideBarTipo(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Asociar tipo de colaborador</Titulo>
        <Formulario
          key={formTipoKey}
          config={tipoAuditorFormConfig}
          loader={loaderTipo}
        />
      </Sidebar>

      <Sidebar
        visible={sideBarNorma}
        onHide={() => setSideBarNorma(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Asociar norma</Titulo>
        <Formulario
          key={formNormaKey}
          config={normaFormConfig}
          loader={loaderNorma}
        />
      </Sidebar>

      <Sidebar
        visible={sideBarEsquema}
        onHide={() => setSideBarEsquema(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Asociar esquema</Titulo>
        <Formulario
          key={formEsquemaKey}
          config={esquemaFormConfig}
          loader={loaderEsquema}
        />
      </Sidebar>

      {loader && (
        <div css={{ marginTop: "2em", display: "flex", flexDirection: "column", gap: "1em" }}>
          {/* Título */}
          <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div css={{ display: "flex", alignItems: "center", gap: "1em" }}>
              <Skeleton width="2rem" height="2rem" shape="circle" />
              <Skeleton width="18rem" height="2rem" />
            </div>
            <Skeleton width="10rem" height="2.5rem" />
          </div>
          {/* Card Detalles */}
          <Card>
            <Skeleton width="6rem" height="1.5rem" css={{ marginBottom: "1.5em" }} />
            <div className="grid">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="col-12 md:col-4">
                  <Skeleton width="60%" height="0.8rem" css={{ marginBottom: "0.5rem" }} />
                  <Skeleton width="3rem" height="1.2rem" />
                </div>
              ))}
            </div>
            <Divider />
            <Skeleton width="40%" height="0.8rem" css={{ marginBottom: "0.5rem" }} />
            <Skeleton width="100%" height="2.5rem" />
          </Card>
          {/* Grid 2 columnas */}
          <div className="grid">
            <div className="col-12 lg:col-6" css={{ display: "flex", flexDirection: "column", gap: "1em" }}>
              <Card>
                <Skeleton width="12rem" height="1.3rem" css={{ marginBottom: "1em" }} />
                <Skeleton width="100%" height="2.5rem" />
              </Card>
            </div>
            <div className="col-12 lg:col-6" css={{ display: "flex", flexDirection: "column", gap: "1em" }}>
              <Card>
                <Skeleton width="8rem" height="1.3rem" css={{ marginBottom: "1em" }} />
                <Skeleton width="100%" height="2.5rem" />
              </Card>
            </div>
          </div>
        </div>
      )}

      {!loader && requerimiento && (
        <div>
          <Titulo
            urlVolver="/formacioncolaborador"
            etiqueta={!activo ? "Inactivo" : undefined}
            error={!activo}
            botones={
              activo ? (
                <Boton
                  transparente
                  rojo
                  loader={loaderEstado}
                  callback={() => cambiarEstadoRequerimiento(false)}
                >
                  Desactivar
                </Boton>
              ) : (
                <Boton
                  transparente
                  rojo
                  loader={loaderEstado}
                  callback={() => cambiarEstadoRequerimiento(true)}
                >
                  Reactivar
                </Boton>
              )
            }
          >
            {requerimiento.nombre}
          </Titulo>

          <Card>
            <Titulo
              chico
              botones={
                <Boton
                  texto
                  negro
                  callback={() => {
                    setFormEditarKey((k) => k + 1);
                    setSideBarEditar(true);
                  }}
                >
                  <i className="pi pi-pencil" />
                </Boton>
              }
            >
              Detalles
            </Titulo>
            <div className="grid">
              <CampoInformacion nombreCampo="Nombre">
                {requerimiento.nombre}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Se debe cumplir por norma">
                {requerimiento.porNorma ? "Sí" : "No"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Se debe cumplir por esquema">
                {requerimiento.porEsquema ? "Sí" : "No"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Requiere archivo">
                {requerimiento.requiereArchivo ? "Sí" : "No"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Duración de renovación (días)">
                {requerimiento.duracionDias || "-"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Obligatorio">
                {requerimiento.obligatorio ? "Sí" : "No"}
              </CampoInformacion>
            </div>
            <Divider />
            <div className="grid">
              <CampoInformacion nombreCampo="Notas" anchoCompleto>
                <span css={{ whiteSpace: "pre-wrap" }}>
                  {requerimiento.notas || "-"}
                </span>
              </CampoInformacion>
            </div>
          </Card>

          <div className="grid" css={{ marginTop: "1em" }}>
            <div
              className="col-12 lg:col-6"
              css={{ display: "flex", flexDirection: "column", gap: "1em" }}
            >
              <Card>
                <Titulo
                  chico
                  botones={
                    <Boton
                      texto
                      negro
                      callback={() => {
                        setFormTipoKey((k) => k + 1);
                        setSideBarTipo(true);
                      }}
                    >
                      <i className="pi pi-plus" />
                    </Boton>
                  }
                >
                  Tipos de colaborador
                </Titulo>
                {tiposAuditor.length === 0 && (
                  <p css={{ color: "var(--grisTextos)" }}>
                    No hay tipos configurados. Aplica a todos.
                  </p>
                )}
                {tiposAuditor.length > 0 && (
                  <TablaFiltrable conFiltros={false}
                    value={tiposAuditor}
                    nombreArchivo="tipos_colaborador_requerimiento"
                    stripedRows
                    size="small"
                    emptyMessage="No hay tipos asociados"
                  >
                    <Column field="etiqueta" header="Tipo" />
                    <Column
                      body={(rowData) => (
                        <Boton
                          texto
                          rojo
                          chico
                          callback={() => eliminarTipoAuditor(rowData.id)}
                        >
                          <i className="pi pi-trash" />
                        </Boton>
                      )}
                      style={{ width: "60px", textAlign: "center" }}
                    />
                  </TablaFiltrable>
                )}
              </Card>
            </div>

            <div
              className="col-12 lg:col-6"
              css={{ display: "flex", flexDirection: "column", gap: "1em" }}
            >
              {porNorma && (
                <Card>
                  <Titulo
                    chico
                    botones={
                      <Boton
                        texto
                        negro
                        callback={() => {
                          setFormNormaKey((k) => k + 1);
                          setSideBarNorma(true);
                        }}
                      >
                        <i className="pi pi-plus" />
                      </Boton>
                    }
                  >
                    Normas
                  </Titulo>
                  {normasAsociadas.length === 0 && (
                    <p css={{ color: "var(--grisTextos)" }}>
                      No hay normas configuradas. Aplica a todas.
                    </p>
                  )}
                  {normasAsociadas.length > 0 && (
                    <TablaFiltrable conFiltros={false}
                      value={normasAsociadas}
                      nombreArchivo="normas_requerimiento"
                      stripedRows
                      size="small"
                      emptyMessage="No hay normas asociadas"
                    >
                      <Column field="etiqueta" header="Norma" />
                      <Column
                        body={(rowData) => (
                          <Boton
                            texto
                            rojo
                            chico
                            callback={() => eliminarNorma(rowData.id)}
                          >
                            <i className="pi pi-trash" />
                          </Boton>
                        )}
                        style={{ width: "60px", textAlign: "center" }}
                      />
                    </TablaFiltrable>
                  )}
                </Card>
              )}

              {porEsquema && (
                <Card>
                  <Titulo
                    chico
                    botones={
                      <Boton
                        texto
                        negro
                        callback={() => {
                          setFormEsquemaKey((k) => k + 1);
                          setSideBarEsquema(true);
                        }}
                      >
                        <i className="pi pi-plus" />
                      </Boton>
                    }
                  >
                    Esquemas
                  </Titulo>
                  {esquemasAsociados.length === 0 && (
                    <p css={{ color: "var(--grisTextos)" }}>
                      No hay esquemas configurados. Aplica a todos.
                    </p>
                  )}
                  {esquemasAsociados.length > 0 && (
                    <TablaFiltrable conFiltros={false}
                      value={esquemasAsociados}
                      nombreArchivo="esquemas_requerimiento"
                      stripedRows
                      size="small"
                      emptyMessage="No hay esquemas asociados"
                    >
                      <Column field="etiqueta" header="Esquema" />
                      <Column
                        body={(rowData) => (
                          <Boton
                            texto
                            rojo
                            chico
                            callback={() => eliminarEsquema(rowData.id)}
                          >
                            <i className="pi pi-trash" />
                          </Boton>
                        )}
                        style={{ width: "60px", textAlign: "center" }}
                      />
                    </TablaFiltrable>
                  )}
                </Card>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
